var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1425 1.42935C11.5309 0.782013 12.4691 0.782013 12.8575 1.42935L23.0913 18.4857C23.4912 19.1522 23.0111 20.0002 22.2338 20.0002H1.76619C0.988898 20.0002 0.508785 19.1522 0.9087 18.4857L11.1425 1.42935ZM12.7052 14.0002H11.2948L11 7.0002H13L12.7052 14.0002ZM12 17.0002C12.5523 17.0002 13 16.5525 13 16.0002C13 15.4479 12.5523 15.0002 12 15.0002C11.4477 15.0002 11 15.4479 11 16.0002C11 16.5525 11.4477 17.0002 12 17.0002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.17d43448.svg";
export { ForwardRef as ReactComponent };